import React from "react";
import { Outlet } from "react-router-dom";
import CrmSidebar from "./sidebar";

const CrmDashboardLayout = () => {
  return (
    <div className="flex min-h-screen w-full">
      {/* Sidebar - fixed width, always open */}
      <aside className="w-[260px] shrink-0 h-screen sticky top-0">
        <CrmSidebar />
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto">
        <div className="min-h-full p-4">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default CrmDashboardLayout;